import React from 'react';
import { ContainerBtn, EmptyQuestionsMessage } from '../../styles';
import { LitButton } from '../../../shared/LitButton';
import Summary from "../Summary";
import {
    NO_QUESTIONS_MESSAGE,
    UNAVAILABLE_MESSAGE,
    hasQuestionsToStart,
    isAssessmentUnavailable
} from './assessmentAvailability';

function AssessmentsButtons({ loading, goToAssessment, data, attempts, code, type }) {
    const isUnavailable = isAssessmentUnavailable(data);
    const hasQuestions = hasQuestionsToStart(data);
    return (
        <>
            <ContainerBtn>
                {hasQuestions && <LitButton
                    disabled={loading || isUnavailable}
                    title={isUnavailable ? UNAVAILABLE_MESSAGE : undefined}
                    style={{
                    textTransform: 'uppercase',
                    fontFamily: 'Dosis',
                    paddingLeft: 20,
                    paddingRight: 20,
                    fontSize: 20,
                    }}
                    onClick={goToAssessment}
                    className={`${loading && ' btn-loading'}`}
                >
                    <i className='fa fa-send' /> {data.status === 'Iniciado' ? 'Retomar' : 'Iniciar'}
                </LitButton>}
                {!hasQuestions && (
                    <EmptyQuestionsMessage role="status">
                        {NO_QUESTIONS_MESSAGE}
                    </EmptyQuestionsMessage>
                )}
            </ContainerBtn>
            {attempts.length > 0 && <Summary attempts={attempts} assessmentCode={code} type={type} />}
        </>
    );
}

export default AssessmentsButtons;